import { render, staticRenderFns } from "./ValueMobileSvg.vue?vue&type=template&id=cd5850fc&"
import script from "./ValueMobileSvg.vue?vue&type=script&lang=js&"
export * from "./ValueMobileSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports